module.exports = __webpack_public_path__ + "img/aomen.25fe519a.jpg";